/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiService } from 'app/api';
import { IApplicationContext } from 'app/context/types';
import {
	getObjectValueIfExists,
	getObjectValuesIfExists,
} from 'modules/utilities/Helpers';
import { ICreateMail, IMailDetails } from '../interfaces/mail';

export class MailsService {
	private apiService: ApiService;

	constructor(private applicationContext: IApplicationContext) {
		this.apiService = new ApiService(this.applicationContext);
	}

	getMailById(mailId: number) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().END_USERS_MAILS.GET_MAIL,
					null,
					{ reqPathParam: mailId },
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				}),
		);
	}
	addMail(newMailData: IMailDetails) {
		return new Promise((resolve, reject): Promise<void> => {
			return this.apiService
				.invoke(
					this.applicationContext.getApiConfig().END_USERS_MAILS.ADD_MAIL,
					this.formatMailReqData(newMailData),
				)
				.then((result: any) => {
					resolve(result);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	}
	updateMail(mailToUpdateData: IMailDetails) {
		return new Promise((resolve, reject): Promise<void> => {
			return this.apiService
				.invoke(
					this.applicationContext.getApiConfig().END_USERS_MAILS.UPDATE_MAIL,
					this.formatMailReqData(mailToUpdateData),
				)
				.then((result: any) => {
					resolve(result);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	}
	getAllMails(page?: number) {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().END_USERS_MAILS.GET_MAILS,
					{},
					{
						pathParams: { page: page || 1 },
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				});
		});
	}
	deleteMail(mailId: number) {
		return this.apiService.invoke(
			this.applicationContext.getApiConfig().END_USERS_MAILS.DELETE_MAIL,
			null,
			{ reqPathParam: mailId },
		);
	}

	getMailsTemplates(nextPageUrl?: string) {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().END_USERS_MAILS
						.GET_MAIL_TEMPLATES,
					null,
					{ pathParams: nextPageUrl ? { nextPageUrl } : undefined },
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				});
		});
	}

	private formatMailReqData(mailData: IMailDetails): ICreateMail {
		return {
			...(mailData.id ? { id: mailData.id } : {}),
			title: mailData.title,
			isDraft: mailData.isDraft,
			templatedId: mailData.templateVersion?.template_id || '',
			templateVersionId: mailData.templateVersion?.id || '',
			endUsersFilter: {
				...getObjectValueIfExists(mailData.endUsersFilter, 'gender', -1),
				...getObjectValueIfExists(mailData.endUsersFilter, 'currentRegion', -1),
				...getObjectValueIfExists(mailData.endUsersFilter, 'createdDateFrom'),
				...getObjectValueIfExists(mailData.endUsersFilter, 'createdDateTo'),

				...getObjectValueIfExists(mailData.endUsersFilter, 'countryCode'),
				...getObjectValueIfExists(
					mailData.endUsersFilter,
					'lastInteractionDateFrom',
				),
				...getObjectValueIfExists(
					mailData.endUsersFilter,
					'lastInteractionDateTo',
				),
				onboardingQuestionAnswerFilters:
					mailData.endUsersFilter.onboardingQuestionAnswerFilters,
				fromLessonId: mailData.filterFromLesson?.id,
				toLessonId: mailData?.filterToLesson?.id,
			},
			...getObjectValuesIfExists(mailData, 'scheduledAt', [undefined, '']),
		};
	}
}
